import { TextFieldProps } from "@mui/material";
import FormikTextField from "../FormikTextField/FormikTextField";

export default function ClientIdInput(props: TextFieldProps & { name: string }): JSX.Element {
  return (
    <FormikTextField fullWidth label="Cédula: " variant="outlined" placeholder="000-0000000-0" required {...props} />
  );
}
